'use client';

import React from 'react';

import { useGlobal } from '@/contexts/GlobalContext';

/**
 * チームオーナーラベル
 * @param param0
 * @returns
 */
const OwnerLabel: React.FC = () => {
  /**
   * React context
   */
  const context = useGlobal();

  return (
    <>
      {context.team && (
        <span
          className="inline-flex items-center font-footballlog italic font-mideum text-xs text-green-400 bg-gray-800 border border-gray-800 rounded px-2 py-1"
          // style={{
          //   color: `${context.team.color_b}`,
          //   border: `solid 1px ${context.team.color_b}`
          // }}
        >
          Owner
        </span>
      )}
    </>
  );
};

export default OwnerLabel;
